import { render, staticRenderFns } from "./CenBsCollFromRegForm.vue?vue&type=template&id=15c41b87&scoped=true&"
import script from "./CenBsCollFromRegForm.vue?vue&type=script&lang=js&"
export * from "./CenBsCollFromRegForm.vue?vue&type=script&lang=js&"
import style0 from "./CenBsCollFromRegForm.vue?vue&type=style&index=0&id=15c41b87&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c41b87",
  null
  
)

export default component.exports